import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const RoleKey = 'role-key'
const RouterKey = 'router-key'
const nameKey ="user-info";
export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

// 保存用户角色
export function getUrole () {
  return JSON.parse(localStorage.getItem(RoleKey));
}

export function setUrole (key) {
  return localStorage.setItem(RoleKey, JSON.stringify(key));
}

export function removeUrole () {
  return localStorage.removeItem(RoleKey)
}


// 保存用户名
export function getUserInfo () {
  return JSON.parse(localStorage.getItem(nameKey));
}

export function setUserInfo (key) {
  return localStorage.setItem(nameKey,JSON.stringify(key));
}

export function removeUserInfo () {
  return localStorage.removeItem(nameKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js